module.exports = __webpack_public_path__ + "img/tip-image-5.921d5669.png";